/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoEfsModelsEfsDefaultFormat,
    EfsMelcoEfsModelsEfsDefaultFormatFromJSON,
    EfsMelcoEfsModelsEfsDefaultFormatFromJSONTyped,
    EfsMelcoEfsModelsEfsDefaultFormatToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoEfsModelsEfsUserResponseSetting
 */
export interface EfsMelcoEfsModelsEfsUserResponseSetting {
    /**
     * 
     * @type {boolean}
     * @memberof EfsMelcoEfsModelsEfsUserResponseSetting
     */
    enable_advanced_options?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EfsMelcoEfsModelsEfsUserResponseSetting
     */
    enable_debug?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EfsMelcoEfsModelsEfsUserResponseSetting
     */
    enable_folder_grouping?: boolean;
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsEfsDefaultFormat>}
     * @memberof EfsMelcoEfsModelsEfsUserResponseSetting
     */
    output_format?: Array<EfsMelcoEfsModelsEfsDefaultFormat> | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsEfsUserResponseSetting
     */
    measurement_unit: string;
}

export function EfsMelcoEfsModelsEfsUserResponseSettingFromJSON(json: any): EfsMelcoEfsModelsEfsUserResponseSetting {
    return EfsMelcoEfsModelsEfsUserResponseSettingFromJSONTyped(json, false);
}

export function EfsMelcoEfsModelsEfsUserResponseSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoEfsModelsEfsUserResponseSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enable_advanced_options': !exists(json, 'enable_advanced_options') ? undefined : json['enable_advanced_options'],
        'enable_debug': !exists(json, 'enable_debug') ? undefined : json['enable_debug'],
        'enable_folder_grouping': !exists(json, 'enable_folder_grouping') ? undefined : json['enable_folder_grouping'],
        'output_format': !exists(json, 'output_format') ? undefined : (json['output_format'] === null ? null : (json['output_format'] as Array<any>).map(EfsMelcoEfsModelsEfsDefaultFormatFromJSON)),
        'measurement_unit': json['measurement_unit'],
    };
}

export function EfsMelcoEfsModelsEfsUserResponseSettingToJSON(value?: EfsMelcoEfsModelsEfsUserResponseSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enable_advanced_options': value.enable_advanced_options,
        'enable_debug': value.enable_debug,
        'enable_folder_grouping': value.enable_folder_grouping,
        'output_format': value.output_format === undefined ? undefined : (value.output_format === null ? null : (value.output_format as Array<any>).map(EfsMelcoEfsModelsEfsDefaultFormatToJSON)),
        'measurement_unit': value.measurement_unit,
    };
}


